import FormComp from "../FormsComp";

export const getDados = (servico) => {
    return [
        {
            titulo: 'Nome do Serviço',
            valor: servico?.nome || '',
            name: 'nome',
            tipo: 'Input',
            placeholder: 'Digite o nome do serviço',
            required: true
        }
    ]
};


export const getComponentMap = (handleInputChange) => {
    return {
        Geral: (dado) => <FormComp dados={dado} handleInputChange={handleInputChange} />,
    }
}